import { useSessionInfo } from './useSessionInfo'

export const SessionInfoService = () => {
  useSessionInfo()
  return null
}
